import { Injectable } from '@angular/core';

export enum PixelEventType {
  POSITION_DETAIL_PAGE_VIEW,
  NEW_USER_SIGN_UP
}

@Injectable({
  providedIn: 'root'
})
export class AppcastService {

  constructor() { }

  private createAndAppendScripts(urls: string[], userId: string, jobId: string) {

    urls.forEach((url) => {
      const node = document.createElement('script');
      node.src = `https://click.appcast.io/pixels/${url}`;
      if (userId) {
        node.src += `&jsid=${userId}`;
      }
      if (jobId) {
        node.src += `&jid=${jobId}`;
      }
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('head')[0].appendChild(node);
    })
}

  fireTrackingPixel(event: PixelEventType, userId?: string, jobId?: string) {
    
    if (event === PixelEventType.POSITION_DETAIL_PAGE_VIEW) {
      const positionPageViewUrls = ["homegrown1-20653.js?ent=417", "generic1-9593.js?ent=315"]
      this.createAndAppendScripts(positionPageViewUrls, userId, jobId)

    } else if (event === PixelEventType.NEW_USER_SIGN_UP) {
      const newSignUpUrls = ["homegrown3-20653.js?ent=417", "generic3-9593.js?ent=315"]
      this.createAndAppendScripts(newSignUpUrls, userId, jobId)
    }
  }
}
